import { render, staticRenderFns } from "./inventory-product-title.vue?vue&type=template&id=3539be78&scoped=true&"
import script from "./inventory-product-title.vue?vue&type=script&lang=js&"
export * from "./inventory-product-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539be78",
  null
  
)

export default component.exports